import { render, staticRenderFns } from "./OrderValidationCardComponent.vue?vue&type=template&id=34737fd4&"
import script from "./OrderValidationCardComponent.vue?vue&type=script&lang=js&"
export * from "./OrderValidationCardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports